const state = {
    effectiveMonth: '',
    clientRequestMidMonth: false,
    midMonthEffectiveDate: '',
    termChecked: false,
}

const mutations = {
    SET_EFFECTIVE_MONTH(state, value) {
        state.effectiveMonth = value;
    },
    SET_CLIENT_REQUEST_MID_MONTH(state, value) {
        state.clientRequestMidMonth = value;
        state.effectiveMonth = '';
        state.midMonthEffectiveDate = '';
        state.termChecked = false;
    },
    SET_MID_MONTH_EFFECTIVE_DATE(state, value) {
        state.midMonthEffectiveDate = value;
    },
    SET_TERM_CHECKED(state, value) {
        state.termChecked = value;
    },
}

export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/components/RentAdjustment/FormTabs/Detail/DetailFormStep/EffectiveDate/store.js